var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#606060;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.7,25.3c-0.6-2.4-2-4.5-3.9-6C40.8,17.8,38.4,17,36,17h-1.8c-0.7-2.2-1.8-4.3-3.3-6 c-1.7-1.9-3.8-3.5-6.1-4.5c-2.3-1-4.9-1.5-7.5-1.4c-2.6,0.1-5.1,0.8-7.3,2c-2.3,1.2-4.2,2.9-5.8,5c-1.5,2.1-2.5,4.5-3,7 c-0.5,2.5-0.3,5.1,0.4,7.6c0.7,2.5,1.9,4.8,3.6,6.7c0.4,0.4,1,0.5,1.4,0.1c0.4-0.4,0.5-1,0.1-1.4c-1.5-1.7-2.6-3.7-3.2-5.9 c-0.6-2.2-0.7-4.5-0.3-6.7c0.4-2.2,1.3-4.4,2.6-6.2C7.2,11.3,9,9.8,11,8.8c2-1.1,4.2-1.7,6.5-1.7C19.7,6.9,22,7.4,24,8.3 c2.1,0.9,3.9,2.3,5.4,4s2.5,3.8,3.1,6c0.1,0.4,0.5,0.8,1,0.8H36c2,0,4,0.7,5.5,1.9c1.6,1.2,2.7,3,3.2,4.9c0.5,1.9,0.3,4-0.5,5.8 c-0.8,1.8-2.2,3.4-3.9,4.3c-0.5,0.3-0.7,0.9-0.4,1.4c0.2,0.3,0.5,0.5,0.9,0.5c0.2,0,0.3,0,0.5-0.1c2.1-1.2,3.8-3,4.8-5.3 C47,30.2,47.3,27.6,46.7,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.7,23.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2-0.1-0.5-0.1-0.8,0c-0.1,0.1-0.2,0.1-0.3,0.2l-8,8 c-0.4,0.4-0.4,1,0,1.4s1,0.4,1.4,0l6.3-6.3V42c0,0.6,0.4,1,1,1s1-0.4,1-1V26.4l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L24.7,23.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.a96a46e9a7895458b29a9b9a1eeb2720.svg";
export { ForwardRef as ReactComponent };